import { Component, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { tap, catchError, of } from 'rxjs';
import { BasicResult } from 'src/app/core-module/models/basic-result';
import { Campaign } from 'src/app/core-module/models/Campaigns/campaign';
import { CampaignDetail } from 'src/app/core-module/models/Campaigns/campaign-detail';
import { CampaignDetailResult } from 'src/app/core-module/models/Campaigns/campaign-detail-result';
import { CampaignListRequest } from 'src/app/core-module/models/Campaigns/campaign-list-request';
import { CampaignListResult } from 'src/app/core-module/models/Campaigns/campaign-list-result';
import { CampaignReturn } from 'src/app/core-module/models/Campaigns/campaign-return';
import { Toastr } from 'src/app/core-module/models/Utils/toastr';
import { AuditRequestsService } from 'src/app/core-module/services/audit-requests.service';
import { ToastrService } from 'src/app/core-module/services/toastr.service';
import { UtilService } from 'src/app/core-module/services/util.service';
import { environment } from 'src/environments/environment';
import {Clipboard} from '@angular/cdk/clipboard';

@Component({
  selector: 'app-campaign-list',
  templateUrl: './campaign-list.component.html',
  styleUrl: './campaign-list.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class CampaignListComponent {

  public campaigns: CampaignListResult = new CampaignListResult()
  public loadedCampaigns: boolean = false;
  public confirmStopCampaign: boolean = true;

  public showOptions: boolean = false;
  public displayClosed: boolean = false;
  public displayExpired: boolean = false;
  public editingCampaign: boolean = false;

  public displayActionSectionBar: boolean = false;
  public temporaryEditCampaign: Campaign = new Campaign();
  public editMade: boolean = false;
  public currentReturnURL: string = '/settings';
  private standardReturnURL: string = '/settings';
  private altReturnURL: string = 'return';
  public recipientsLoading: boolean = false;
  public recipientsLoaded: boolean = false;
  private editRecipientReturn: CampaignDetailResult = new CampaignDetailResult();
  public editRecipients: CampaignDetail[] = [];

  public errCampaignName: boolean = false;
  public errAuditName: boolean = false;
  public errStartDate: boolean = false;
  public errExpiryDate: boolean = false;
  public closeAuditOption: boolean = false;

  public isHoveringAdd: boolean = false;
  public addingNewRecipient: boolean = false;
  public newName: string = "";
  public newRef: string = "";
  public newEmail: string = "";
  public errorEmail: boolean = false;
  public selectedGDPR: boolean = false;

  public showKey: boolean = false;

  public isSaving: boolean = false;

  public isBluebird: boolean = false;



  constructor(private campaignService: AuditRequestsService, private utilService: UtilService, private toastr: ToastrService, private util: UtilService, private router: Router,private clipboard: Clipboard) {
    this.getCampaignList(false, false);
    if (environment.blueBird) {
      this.isBluebird = true;
    }
  }
  copyLink(link:string){
    this.clipboard.copy(link);
    this.toastr.addToastr(new Toastr({ Message: "Link Copied.", Type: 2 }))
  }
  openLink(link:string){
    window.open(link,'_blank');
  }

  getCampaignList(includeClosed: boolean, includeExpired: boolean) {
    var request: CampaignListRequest = new CampaignListRequest({ IncludeExpired: includeExpired, IncludeInactive: includeClosed });
    this.campaignService.getCampaignList(request).pipe(tap((res: CampaignListResult) => {
      if (res.IsError) {

      } else {
        this.campaigns = new CampaignListResult(res);
        this.loadedCampaigns = true;
      };
    })).subscribe();
  }
  editCampaign(c: Campaign) {
    if (!c.Active) {
      return;
    }
    this.temporaryEditCampaign = new Campaign(c);
    this.currentReturnURL = this.altReturnURL;
    this.editingCampaign = true;
    this.displayActionSectionBar = true;
  }
  cancelEdit() {
    this.temporaryEditCampaign = new Campaign();
    this.currentReturnURL = this.standardReturnURL;
    this.displayActionSectionBar = false;
    this.editingCampaign = false;
    this.recipientsLoaded = false;
    this.editMade = false;
  }
  switchPendingStopCampaign(c: Campaign) {
    c.PendingStop = !c.PendingStop;
  }
  stopCampaign(c: Campaign) {
    if (!c.Active) {
      return;
    }
    this.campaignService.haltCampaign(c).pipe(tap((res: BasicResult) => {
      if (res.IsError) {
        this.toastr.addToastr(new Toastr({ Type: 3, Message: "Unable to update feedback campaign, please try again." }));
      } else {
        this.toastr.addToastr(new Toastr({ Type: 2, Message: "Feedback campaign stopped." }))
        this.getCampaignList(this.displayClosed, this.displayExpired);
      }
    })).subscribe();

  }
  changeDisplayOptions() {
    this.showOptions = !this.showOptions;
  }
  humaniseDate(inputDate: Date) {
    return this.utilService.shortHumanDate(inputDate);
  }


  reloadPage() {
    this.getCampaignList(this.displayClosed, this.displayExpired);
  }

  createCampaign() {
    this.router.navigateByUrl('settings/campaigns/newcampaign');
  }


  removeReceipient(GUID: string) {
    var id: number = this.editRecipients.findIndex(e => e.GUID == GUID);
    if (id != -1) {
      this.editRecipients.splice(id, 1);
    }
    this.registerEditChange();
  }
  editCampaignName() {
    if (this.temporaryEditCampaign.RequestName.length == 0) {
      this.errCampaignName = true;
    } else {
      this.errCampaignName = false;
    }
    this.registerEditChange();
  }
  editAuditName() {
    if (this.temporaryEditCampaign.PublicAuditName.length == 0) {
      this.errAuditName = true;
    } else {
      this.errAuditName = false;
    }
    this.registerEditChange();
  }
  editSendDate() {
    var sendDateDate = new Date(this.temporaryEditCampaign.SendDate.getFullYear(), this.temporaryEditCampaign.SendDate.getMonth(), this.temporaryEditCampaign.SendDate.getDate());
    var currentDate = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate());

    if (sendDateDate < currentDate) {
      this.errStartDate = true;
    } else {
      this.errStartDate = false;
    }
    this.registerEditChange();
  }
  editExpiryDate() {
    var SD: Date = new Date(this.temporaryEditCampaign.SendDate);
    var ED: Date = new Date(this.temporaryEditCampaign.ExpiryDate);
    var expiryDateDate = new Date(ED.getFullYear(), ED.getMonth(), ED.getDate());
    var sendDateDate = new Date(SD.getFullYear(), SD.getMonth(), SD.getDate());
    var currentDate = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate());

    if (expiryDateDate < sendDateDate) {
      this.errStartDate = true;
    } else {
      this.errStartDate = false;
    }
    if (expiryDateDate < currentDate) {
      this.closeAuditOption = true;
    } else {
      this.closeAuditOption = false;
    }

    this.registerEditChange();
  }
  registerEditChange() {
    this.editMade = true;
  }
  undoRequest() {
    if (this.campaigns.Campaigns.findIndex(x => x.AuditRequestID == this.temporaryEditCampaign.AuditRequestID) == -1) {
      return;
    }
    var originalCampaign: Campaign = this.campaigns.Campaigns.find(x => x.AuditRequestID == this.temporaryEditCampaign.AuditRequestID)!
    this.temporaryEditCampaign = new Campaign(originalCampaign);
    if (this.recipientsLoaded) {
      this.buildRecipients();
    }
    this.editMade = false;
  }
  loadRecipients() {
    this.recipientsLoading = true;
    this.campaignService.getCampaignRecipients(this.temporaryEditCampaign).pipe(tap((res: CampaignDetailResult) => {
      if (res.IsError) {
        this.toastr.addToastr(new Toastr({ Type: 3, Message: "Unable to load recipients, please try again." }));
        this.recipientsLoading = false;
      } else {
        this.editRecipientReturn = new CampaignDetailResult(res);
        this.buildRecipients();
      }
    }), catchError((error) => {
      this.toastr.addToastr(new Toastr({ Type: 3, Message: "Unable to load recipients, please try again." }));
      this.recipientsLoading = false;
      return of(null);
    })).subscribe()
  }
  buildRecipients() {
    this.editRecipients = []
    if (this.editRecipientReturn.CampaignDetails.length == 0) {
      this.recipientsLoading = false;
      return;
    } else {
      this.editRecipientReturn.CampaignDetails.forEach(e => {
        this.editRecipients.push(new CampaignDetail(e));
      })
      this.recipientsLoading = false;
      this.recipientsLoaded = true;
    }
  }
  showAddRecipient() {
    this.isHoveringAdd = false;
    this.addingNewRecipient = true;
    this.scroll();
  }
  validReceipient(): boolean {
    var validReceipient: boolean = true;
    if (!this.util.validEmail(this.newEmail)) {
      validReceipient = false;
      this.errorEmail = true;
    }
    return validReceipient;
  }
  resetEmailValidation() {
    this.errorEmail = false;
  }
  addReceipient() {
    if (this.validReceipient()) {
      var r: CampaignDetail = new CampaignDetail();
      r.Email = this.newEmail;
      r.Name = this.newName;
      r.Reference = this.newRef;
      r.GUID = crypto.randomUUID();
      this.editRecipients.push(r);
      this.clearRecipientEntry();
      this.addingNewRecipient = false;
      this.registerEditChange();
    }

  }
  cancelAddRecipient() {
    this.isHoveringAdd = false;
    this.addingNewRecipient = false;
  }
  clearRecipientEntry() {
    this.newEmail = "";
    this.newName = "";
    this.newRef = "";
    this.selectedGDPR = false;

  }
  scroll() {
    var el: HTMLElement = document.getElementById('permissionCheck')!;
    el.scrollIntoView({ behavior: 'smooth' });
  }
  changeHelp() {
    this.showKey = !this.showKey;
  }
  changeViewLink(c: Campaign) {

    c.ViewLink = !c.ViewLink;

  }

  linkCreator(link: string): string {
    var returnString: string = '';
    if (this.isBluebird) {
      returnString += 'https://bluebirdcare.careaudits.co.uk';
    } else {
      returnString += 'https://app.careaudits.co.uk';
    }
    returnString += '/entryform?link=' + link;
    return returnString;
  }

  saveCampaignChanges() {
    this.isSaving = true;
    this.temporaryEditCampaign.Recipients = this.editRecipients;
    this.temporaryEditCampaign.RecipientsLoaded = this.recipientsLoaded;
    this.temporaryEditCampaign.SendDate = this.util.removeTimezoneFromDate(new Date(this.temporaryEditCampaign.SendDate));
    this.temporaryEditCampaign.ExpiryDate = this.util.removeTimezoneFromDate(new Date(this.temporaryEditCampaign.ExpiryDate));
    this.campaignService.updateCampaign(this.temporaryEditCampaign).pipe(tap((res: BasicResult) => {
      if (res.IsError) {
        this.toastr.addToastr(new Toastr({ Type: 3, Message: "Unable to save feedback campaign changes, please try again." }));
        this.isSaving = false;
      } else {
        this.toastr.addToastr(new Toastr({ Type: 2, Message: "Feedback campaign updated." }));
        this.isSaving = false;
        this.cancelEdit();
        this.getCampaignList(this.displayClosed, this.displayExpired);
      }
    }), catchError((error) => {
      this.toastr.addToastr(new Toastr({ Type: 3, Message: "Unable to save feedback campaign changes, please try again." }));
      this.recipientsLoading = false;
      return of(null);
    })).subscribe();
    //send return
  }
}
